export default {
    delete_clip_request_title: "Eliminar Clip",
    delete_clip_request_success_message: "El clip ha sido eliminado",
    delete_clip_request_error_message: "No se ha podido eliminar el clip",
    delete_clip_request_message: "¿Estás seguro de que quieres eliminar el clip?",
}